import React from 'react';
import MarkdownPage from '../Components/InfoPages/MarkdownPage';

function FAQPage() {
  return <MarkdownPage slug="faq" titleKey="infoPages.faq.title" descriptionKey="infoPages.faq.description" />;
}

export default FAQPage;
